import styled from 'styled-components';
import './theme.js';
import { typographyMixin } from './typographyMixin.js';
/** `Typography` is responsible for styling the text according to the designs */
export const Typography = styled.div `
  ${({ size = 'sm', type = 'regular' }) => typographyMixin({ size, type })};
`;
